import React from "react";
import { isTimelineEndDatePassed } from "../../../utils/timelineAssetDates";
import { PHASE_DOT_CLASS, PHASE_LABEL } from "./clientCampaignStatus";

export default function ClientCampaignBar({ campaign, phase, style }) {
  // Always use the campaign's own color — phase.theme_color is per-asset and not relevant here.
  const campaignColor = campaign.theme_color || "#6b7280";
  const isPast = isTimelineEndDatePassed(phase.end_date);
  const phaseDotClass = PHASE_DOT_CLASS[phase.phase] || PHASE_DOT_CLASS.main;
  const phaseLabel = PHASE_LABEL[phase.phase] || phase.phase;

  return (
    <div
      className={`absolute top-1 bottom-1 flex items-center overflow-hidden rounded-md px-2 ${
        isPast
          ? "bg-gray-100 opacity-75 dark:bg-rb-dark-mode-lighter/60"
          : "bg-white shadow-sm dark:bg-rb-dark-mode-lighter"
      }`}
      style={style}
    >
      <div className="flex min-w-0 flex-1 items-center gap-1.5">
        <span
          className="flex h-5 w-5 flex-shrink-0 items-center justify-center rounded text-[8px] font-bold text-white"
          style={{ backgroundColor: campaignColor }}
        >
          {campaign.name.slice(0, 2).toUpperCase()}
        </span>
        <span
          className={`min-w-0 truncate text-xs font-medium ${
            isPast
              ? "text-rb-lighter-grey dark:text-gray-400"
              : "text-rb-black dark:text-white"
          }`}
        >
          {campaign.name} -
        </span>
        <span
          className={`flex flex-shrink-0 items-center gap-1 text-xs ${
            isPast
              ? "text-rb-lighter-grey dark:text-gray-400"
              : "text-gray-500 dark:text-gray-400"
          }`}
        >
          <span className={`h-1.5 w-1.5 rounded-full ${phaseDotClass}`} />
          {phaseLabel}
        </span>
      </div>
    </div>
  );
}
